import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import API_BASE_URL from "../../../constants/api";

interface TagsProps {
  onSelect: (tag: string) => void;
}

const Tags = ({ onSelect }: TagsProps) => {
  const [tags, setTags] = useState<string[]>([]);

  useEffect(() => {
  axios.get(`${API_BASE_URL}tags`)
      .then((res) => setTags(res.data))
      .catch((err) => console.error('Failed to fetch tags:', err));
  }, []);

  return (
    <div className="blog-widget">
      <h4 className="widget-title">Tags</h4>
      <div className="tagcloud">
        {tags.map((tag, i) => (
          <Link key={i} to="#" onClick={() => onSelect(tag)}>
            {tag}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Tags;
